'use strict';

var Model = require('base/Colido.Model')

/**
 * Model for a single rfid scanner
 *
 * @category   Model
 * @module     global
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */
var ScannerModel = Model.extend({
    api: '/scanners',

    defaults: {
        id: null,
        name: 'Scanner',
        tags: [],
    },
});

module.exports = ScannerModel;